"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxToggle = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _reactIntl = require("react-intl");

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

var _primitiveMessages = require("../primitiveMessages");

var _FieldLayout = require("../layout/FieldLayout");

var _LinkExternalWithHref = require("../LinkExternalWithHref");

var _FieldValidationMessage = require("./FieldValidationMessage");

var _fieldUtils = require("./fieldUtils");

var _fieldAttrsUtils = require("./fieldAttrsUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * CheckboxToggle input type=checkbox
 * therefore this component assumes value is boolean
 */
var CheckboxToggle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CheckboxToggle, _React$Component);

  function CheckboxToggle(props) {
    var _this;

    _classCallCheck(this, CheckboxToggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxToggle).call(this, props));
    var value = _this.props.value;
    /**
    https://reactjs.org/docs/events.html#event-pooling (BOOM-5825)
    using isChecked state to avoid directly accessing input.value for updates
    which can be nullified when the event is no longer active
    Specifically:
    using event.persist() as referenced in the link above did not work to remedy this situation
    i could log input.value and watch it's value change to the synthetic event when using the spacebar
    (seemed to work fine onClick)
    the issues do not occur when accessing input.value when using reduxForm
    */
    // this component expects to be passed a boolean initial value on value

    var initValue = typeof value === 'boolean' ? value : false;
    _this.state = {
      isChecked: initValue,
      isFocused: false
    };
    _this.setWrapperRef = _this.setWrapperRef.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.toggleCheckedState = _this.toggleCheckedState.bind(_assertThisInitialized(_this));
    _this.containerProps = _this.containerProps.bind(_assertThisInitialized(_this));
    _this.labelProps = _this.labelProps.bind(_assertThisInitialized(_this));
    _this.fieldProps = _this.fieldProps.bind(_assertThisInitialized(_this));
    _this.clickHandler = _this.clickHandler.bind(_assertThisInitialized(_this));
    _this.controlProps = _this.controlProps.bind(_assertThisInitialized(_this));
    _this.toggleTextProps = _this.toggleTextProps.bind(_assertThisInitialized(_this));
    _this.toggleText = _this.toggleText.bind(_assertThisInitialized(_this));
    _this.validationMsgProps = _this.validationMsgProps.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CheckboxToggle, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      var onChange = this.props.onChange;
      var isChecked = this.state.isChecked;

      if (nextState.isChecked !== isChecked) {
        onChange(nextState.isChecked);
      }
    }
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      var onFocus = this.props.onFocus;

      if (onFocus) {
        onFocus(event);
      }

      this.setState({
        isFocused: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      var onBlur = this.props.onBlur;

      if (onBlur) {
        onBlur(event);
      }

      this.setState({
        isFocused: false
      });
    }
  }, {
    key: "toggleCheckedState",
    value: function toggleCheckedState() {
      var isChecked = this.state.isChecked; // toggle state in the click event
      // .onChange will then be called in componentWillUpdate

      this.setState({
        isChecked: !isChecked
      });
    }
  }, {
    key: "clickHandler",
    value: function clickHandler() {
      // onClick : document.activeElement = <body>
      // manually focus - to keep focus on element
      if (this.wrapperRef) {
        this.wrapperRef.focus();
      }

      this.toggleCheckedState();
    }
  }, {
    key: "containerProps",
    value: function containerProps() {
      var _this$props = this.props,
          name = _this$props.name,
          cashbotName = _this$props.cashbotName,
          styleType = _this$props.styleType;
      return _objectSpread({}, (0, _fieldAttrsUtils.fieldContainerAttributes)({
        fieldName: name,
        cashbotName: cashbotName
      }), {
        className: "".concat(styleType, "-container")
      });
    }
  }, {
    key: "labelProps",
    value: function labelProps(showInvalid) {
      var _this$props2 = this.props,
          styleType = _this$props2.styleType,
          name = _this$props2.name;
      return _objectSpread({}, (0, _fieldAttrsUtils.labelAttributes)({
        fieldName: name,
        isInvalid: showInvalid
      }), {
        className: (0, _dedupe.default)("".concat(styleType, "-control__label"), _defineProperty({}, "".concat(styleType, "-control__label--error"), showInvalid))
      });
    }
  }, {
    key: "fieldProps",
    value: function fieldProps(showInvalid) {
      var _this$props3 = this.props,
          name = _this$props3.name,
          value = _this$props3.value,
          label = _this$props3.label,
          onChange = _this$props3.onChange,
          styleType = _this$props3.styleType,
          isRequiredField = _this$props3.isRequiredField;
      var isChecked = this.state.isChecked;
      return _objectSpread({}, (0, _fieldAttrsUtils.inputAttributes)({
        fieldName: name,
        label: label,
        isRequiredField: isRequiredField,
        isInvalid: showInvalid
      }), {
        type: 'checkbox',
        name: name,
        value: value,
        className: "".concat(styleType, "-control__input"),
        checked: isChecked,
        onChange: onChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      });
    }
  }, {
    key: "controlProps",
    value: function controlProps(showInvalid) {
      var _classNames2;

      var _this$state = this.state,
          isFocused = _this$state.isFocused,
          isChecked = _this$state.isChecked;
      var styleType = this.props.styleType;
      return {
        className: (0, _dedupe.default)("".concat(styleType, "-control"), (_classNames2 = {
          'checkbox-control--checked': isChecked && styleType === 'checkbox',
          'checkbox-control--unchecked': !isChecked && styleType === 'checkbox',
          'toggle-control--on': isChecked && styleType === 'toggle',
          'toggle-control--off': !isChecked && styleType === 'toggle'
        }, _defineProperty(_classNames2, "".concat(styleType, "-control--error"), showInvalid), _defineProperty(_classNames2, "".concat(styleType, "-focused"), isFocused), _classNames2)),
        onClick: this.clickHandler
      };
    }
  }, {
    key: "toggleTextProps",
    value: function toggleTextProps() {
      var isChecked = this.state.isChecked;
      return {
        className: (0, _dedupe.default)('toggle-control__text', {
          'toggle-control__text--on': isChecked,
          'toggle-control__text--off': !isChecked
        })
      };
    }
  }, {
    key: "toggleText",
    value: function toggleText() {
      var isChecked = this.state.isChecked;
      var checkboxToggleYes = _primitiveMessages.primitiveMessages.checkboxToggleYes,
          checkboxToggleNo = _primitiveMessages.primitiveMessages.checkboxToggleNo;
      var text = isChecked ? checkboxToggleYes : checkboxToggleNo;
      return _react.default.createElement(_reactIntl.FormattedMessage, text);
    }
  }, {
    key: "validationMsgProps",
    value: function validationMsgProps(validationProps) {
      var name = this.props.name;
      var fieldIds = (0, _fieldUtils.getAllFieldElementIds)(name);
      return {
        id: fieldIds.validation.id,
        fieldName: name,
        validationProps: validationProps
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          label = _this$props4.label,
          styleType = _this$props4.styleType,
          openLinksInNewTab = _this$props4.openLinksInNewTab,
          cashbotName = _this$props4.cashbotName,
          name = _this$props4.name,
          value = _this$props4.value,
          isInvalid = _this$props4.isInvalid,
          isTouched = _this$props4.isTouched,
          warningMessage = _this$props4.warningMessage,
          errorMessage = _this$props4.errorMessage;
      var options = {};

      if (openLinksInNewTab) {
        /* eslint-disable id-length */
        options.overrides = {
          a: {
            component: _LinkExternalWithHref.LinkExternalWithHref
          }
        };
      }

      var validationProps = (0, _fieldUtils.getValidationProps)(value, isInvalid, isTouched, warningMessage, errorMessage);
      var showInvalid = validationProps.isInvalid;
      return _react.default.createElement(_FieldLayout.FieldWrapper, {
        fieldName: name,
        cashbotName: cashbotName
      }, styleType === 'checkbox' && _react.default.createElement("div", this.containerProps(), _react.default.createElement("div", this.controlProps(showInvalid), _react.default.createElement("input", _extends({
        ref: this.setWrapperRef
      }, this.fieldProps(showInvalid)))), _react.default.createElement("label", this.labelProps(showInvalid), _react.default.createElement(_markdownToJsx.default, {
        options: options
      }, label))), styleType === 'toggle' && _react.default.createElement("div", this.containerProps(), _react.default.createElement("label", this.labelProps(showInvalid), _react.default.createElement(_markdownToJsx.default, {
        options: options
      }, label)), _react.default.createElement("div", this.controlProps(showInvalid), _react.default.createElement("input", _extends({
        ref: this.setWrapperRef
      }, this.fieldProps(showInvalid))), _react.default.createElement("span", this.toggleTextProps(), this.toggleText()))), errorMessage && _react.default.createElement(_FieldValidationMessage.FieldValidationMessage, this.validationMsgProps(validationProps)));
    }
  }]);

  return CheckboxToggle;
}(_react.default.Component);

exports.CheckboxToggle = CheckboxToggle;
CheckboxToggle.defaultProps = {
  onFocus: null,
  onBlur: null,
  openLinksInNewTab: false,
  errorMessage: null,
  warningMessage: null,
  isInvalid: false,
  isTouched: false,
  styleType: 'toggle',
  isRequiredField: false
};
CheckboxToggle.propTypes = {
  openLinksInNewTab: _propTypes.default.bool,
  name: _propTypes.default.string.isRequired,
  // When clicking directly on the checkbox, the value is a boolean, but when
  // clicking on the <label> or using the spacebar, it can be an event
  value: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]).isRequired,
  onChange: _propTypes.default.func.isRequired,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  styleType: _propTypes.default.oneOf(['toggle', 'checkbox']),
  errorMessage: _propTypes.default.string,
  warningMessage: _propTypes.default.string,
  isInvalid: _propTypes.default.bool,
  isTouched: _propTypes.default.bool,
  isRequiredField: _propTypes.default.bool
};